import type { Dayjs } from 'dayjs';

const getDateLimits = (calendarName: string) => {
  const match = calendarName.match(/(\d{4})\/(\d{4})/);
  if (match) {
    return {
      startYear: parseInt(match[1]),
      endYear: parseInt(match[2]),
    };
  }
  return null;
};

export const getDisabledDate = (calendarName: string, current: Dayjs) => {
  if (!calendarName) return false;

  const limits = getDateLimits(calendarName);
  if (!limits) return false;

  const year = current.year();
  return year < limits.startYear || year > limits.endYear;
};
